<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Site Survey</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="input-column">
        @if (returnAirPanelHeightSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Panel - Height:</span>
              <input
                type="number"
                class="numeric-input"
                #returnAirPanelHeightInput
                [value]="returnAirPanelHeightSelection.Value"
                (change)="selectionChanged(returnAirPanelHeightSelection, returnAirPanelHeightInput.value || '0')" />
            </span>
          </div>
        }
        @if (returnAirPanelWidthSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Panel - Width:</span>
              <input
                type="number"
                class="numeric-input"
                #returnAirPanelWidthInput
                [value]="returnAirPanelWidthSelection.Value"
                (change)="selectionChanged(returnAirPanelWidthSelection, returnAirPanelWidthInput.value || '0')" />
            </span>
          </div>
        }
        @if (returnAirPanelAboveFloorSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Panel above Floor:</span>
              <input
                type="number"
                class="numeric-input"
                #returnAirPanelAboveFloorInput
                [value]="returnAirPanelAboveFloorSelection.Value"
                (change)="selectionChanged(returnAirPanelAboveFloorSelection, returnAirPanelAboveFloorInput.value || '0')" />
            </span>
          </div>
        }
        @if (returnAirOpeningHeightSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Opening - Height:</span>
              <input
                type="number"
                class="numeric-input"
                #returnAirOpeningHeightInput
                [value]="returnAirOpeningHeightSelection.Value"
                (change)="selectionChanged(returnAirOpeningHeightSelection, returnAirOpeningHeightInput.value || '0')" />
            </span>
          </div>
        }
        @if (returnAirOpeningWidthSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Opening - Width:</span>
              <input
                type="number"
                class="numeric-input"
                #returnAirOpeningWidthInput
                [value]="returnAirOpeningWidthSelection.Value"
                (change)="selectionChanged(returnAirOpeningWidthSelection, returnAirOpeningWidthInput.value || '0')" />
            </span>
          </div>
        }
        @if (returnAirOpeningAboveFloorSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Opening above Floor:</span>
              <input
                type="number"
                class="numeric-input"
                #returnAirOpeningAboveFloorInput
                [value]="returnAirOpeningAboveFloorSelection.Value"
                (change)="selectionChanged(returnAirOpeningAboveFloorSelection, returnAirOpeningAboveFloorInput.value || '0')" />
            </span>
          </div>
        }
        @if (cabinetDepthInsideSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Cabinet Depth - Inside:</span>
              <input
                type="number"
                class="numeric-input"
                #cabinetDepthInsideInput
                [value]="cabinetDepthInsideSelection.Value"
                (change)="selectionChanged(cabinetDepthInsideSelection, cabinetDepthInsideInput.value || '0')" />
            </span>
          </div>
        }
        @if (cabinetWidthInsideSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Cabinet Width - Inside:</span>
              <input
                type="number"
                class="numeric-input"
                #cabinetWidthInsideInput
                [value]="cabinetWidthInsideSelection.Value"
                (change)="selectionChanged(cabinetWidthInsideSelection, cabinetWidthInsideInput.value || '0')" />
            </span>
          </div>
        }
        @if (fanDeckToTopCoilSupportSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Return Air Blockoff Height:</span>
              <input
                type="number"
                class="numeric-input"
                #fanDeckToTopCoilSupportInput
                [value]="fanDeckToTopCoilSupportSelection.Value"
                (change)="selectionChanged(fanDeckToTopCoilSupportSelection, fanDeckToTopCoilSupportInput.value || '0')" />
            </span>
          </div>
        }
        @if (topOfDrainPanToBaseSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Top of Drain Pan to Base:</span>
              <input
                type="number"
                class="numeric-input"
                #topOfDrainPanToBaseInput
                [value]="topOfDrainPanToBaseSelection.Value"
                (change)="selectionChanged(topOfDrainPanToBaseSelection, topOfDrainPanToBaseInput.value || '0')" />
            </span>
          </div>
        }
        @if (fanDeckToPipingSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Fan Deck to Piping:</span>
              <input
                type="number"
                class="numeric-input"
                #fanDeckToPipingInput
                [value]="fanDeckToPipingSelection.Value"
                (change)="selectionChanged(fanDeckToPipingSelection, fanDeckToPipingInput.value || '0')" />
            </span>
          </div>
        }
        @if (pipingElevationSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Piping Elevation:</span>
              <input
                type="number"
                class="numeric-input"
                #pipingElevationInput
                [value]="pipingElevationSelection.Value"
                (change)="selectionChanged(pipingElevationSelection, pipingElevationInput.value || '0')" />
            </span>
          </div>
        }
        @if (blowerHeightSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Blower - Height:</span>
              <input
                type="number"
                class="numeric-input"
                #blowerHeightInput
                [value]="blowerHeightSelection.Value"
                (change)="selectionChanged(blowerHeightSelection, blowerHeightInput.value || '0')" />
            </span>
          </div>
        }
        @if (blowerWidthSelection) {
          <div class="configurationDetailRow">
            <span>
              <span class="halfWidthInputLabel">Blower - Width:</span>
              <input
                type="number"
                class="numeric-input"
                #blowerWidthInput
                [value]="blowerWidthSelection.Value"
                (change)="selectionChanged(blowerWidthSelection, blowerWidthInput.value || '0')" />
            </span>
          </div>
        }
        @if (replacementSelection) {
          <div class="configurationDetailRow">
            <span class="halfWidthInputLabel">Replacement Type:</span>
            <select
              class="halfWidthInputField"
              #replacementTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(replacementSelection.Name)"
              (change)="selectionChanged(replacementSelection, replacementTypeInput.value)"
              [value]="replacementSelection.Value.toString()">
              @for (allowable of replacementSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="replacementSelection.Value && replacementSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </div>
        }
        @if (oeMotorSelection) {
          <div class="configurationDetailRow">
            <span class="halfWidthInputLabel">Original Equipment Motor:</span>
            <select
              class="halfWidthInputField"
              #oeMotorInput
              [class.invalidConfigurationSelection]="isInvalidSelection(oeMotorSelection.Name)"
              (change)="selectionChanged(oeMotorSelection, oeMotorInput.value)"
              [value]="oeMotorSelection.Value.toString()">
              @for (allowable of oeMotorSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="oeMotorSelection.Value && oeMotorSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </div>
        }
        @if (oeControlsSelection) {
          <div class="configurationDetailRow">
            <span class="halfWidthInputLabel">Original Equipment Controls:</span>
            <select
              class="halfWidthInputField"
              #oeControlsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(oeControlsSelection.Name)"
              (change)="selectionChanged(oeControlsSelection, oeControlsInput.value)"
              [value]="oeControlsSelection.Value.toString()">
              @for (allowable of oeControlsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="oeControlsSelection.Value && oeControlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </div>
        }
      </div>
      <div class="image-column">
        @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
          <img class="handArrangementImage" [src]="handArrangementImagePath()" alt="UnitImage" />
        }
      </div>
    </div>
  }
</div>
